/* No checkout or simulated signups. Shopify owns form submission and success. */
(() => {
  'use strict';
  if (window.madballPdpV3) return;
  window.madballPdpV3 = true;
  const cleanups = new Map();
  const init = (root) => {
    if (cleanups.has(root)) return;
    const controller = new AbortController();
    const on = (el, type, fn, options = {}) => el && el.addEventListener(type, fn, { ...options, signal: controller.signal });
    const form = root.querySelector('[data-mbp-form]');
    const sync = () => {
      if (!form) return;
      const input = form.querySelector('[data-mbp-tags]');
      const design = form.querySelector('[data-mbp-design]');
      const size = form.querySelector('[data-mbp-size]:checked');
      const tags = ['newsletter', 'madball-waitlist-v1', 'madball-pdp-v3'];
      if (design && /^[a-z-]+$/.test(design.value)) tags.push('mb-design-' + design.value);
      if (size && size.value !== 'unsure') tags.push('mb-size-' + size.value);
      if (input) input.value = tags.join(',');
    };
    sync();
    on(form, 'change', sync);
    on(form, 'submit', sync);
    const slides = [...root.querySelectorAll('[data-mbp-slide]')];
    const thumbs = [...root.querySelectorAll('[data-mbp-thumb]')];
    const show = (index) => {
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      thumbs.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
    };
    thumbs.forEach((button, i) => {
      on(button, 'click', () => show(i));
      on(button, 'keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
        show(next); thumbs[next].focus();
      });
    });
    const dialog = root.querySelector('[data-mbp-zoom]');
    let opener = null;
    root.querySelectorAll('[data-mbp-enlarge]').forEach((link) => on(link, 'click', (event) => {
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      const img = link.querySelector('img');
      const target = dialog.querySelector('img');
      target.src = link.href; target.alt = img ? img.alt : 'Polo image';
      dialog.querySelector('p').textContent = img ? img.alt : 'Polo image';
      opener = link; dialog.showModal(); document.body.classList.add('mbp-modal-open'); refreshSticky();
    }));
    on(dialog && dialog.querySelector('button'), 'click', () => dialog.close());
    on(dialog, 'click', (event) => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    on(dialog, 'close', () => { document.body.classList.remove('mbp-modal-open'); if (opener && document.contains(opener)) opener.focus({preventScroll:true}); refreshSticky(); });
    const primary = root.querySelector('[data-mbp-primary]');
    const sticky = root.querySelector('[data-mbp-sticky]');
    const footer = document.querySelector('.mb-footer');
    let raf = 0;
    const refreshSticky = () => {
      if (!sticky) return;
      const editing = /^(INPUT|SELECT|TEXTAREA)$/.test(document.activeElement.tagName);
      const past = primary && primary.getBoundingClientRect().bottom < 0;
      const atFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
      sticky.hidden = !(window.matchMedia('(max-width:760px)').matches && past && !editing && !atFooter && !(dialog && dialog.open));
    };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; refreshSticky(); }); };
    on(window, 'scroll', schedule, { passive:true }); on(window, 'resize', schedule);
    on(document, 'focusin', schedule); on(document, 'focusout', schedule);
    root.querySelectorAll('[data-mbp-back-to-form]').forEach((link) => on(link, 'click', (event) => {
      const email = form && form.querySelector('[data-mbp-email]');
      if (!form) return;
      event.preventDefault(); form.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth',block:'start'});
      if (email) email.focus({preventScroll:true});
    }));
    const response = root.querySelector('[data-mbp-response]');
    if (response) response.focus();
    refreshSticky();
    cleanups.set(root, () => { controller.abort(); if (raf) cancelAnimationFrame(raf); document.body.classList.remove('mbp-modal-open'); });
  };
  const scan = () => document.querySelectorAll('[data-mbp-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true}); else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', (event) => { for (const [root, cleanup] of cleanups) { if (event.target.contains(root)) { cleanup(); cleanups.delete(root); } } });
})();
